export default __webpack_public_path__ + "static/media/notFoundPage.10a0846b.gif";